import React from 'react';

import { Helmet } from 'react-helmet';
import { UserProfileForm } from '~/auth';

import { Container, GridLegacy as Grid } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import SalesforceAccessRequest from './components/SalesforceAccessRequest';

export default function ProfilePage() {
  return (
    <Container>
      <Helmet>
        <title>My Account</title>
      </Helmet>

      <PageHeader title="My Account" />
      <UserProfileForm />

      {/* Grid to center the Salesforce Access Request to the same width as the UserProfileForm */}
      <Grid mt={4} justifyContent="center" container>
        <Grid xs={12} md={2} lg={4}>
          <SalesforceAccessRequest />
        </Grid>
      </Grid>
    </Container>
  );
}
